/** biome-ignore-all lint/a11y/useSemanticElements: status badge, same as Pill */

import { formatCounterValue } from "@utils/formatCounterValue";
import type { JSX } from "solid-js";
import { splitProps } from "solid-js";
import "./Counter.css";

export { formatCounterValue } from "@utils/formatCounterValue";

type CounterTheme =
	| "success"
	| "warning"
	| "error"
	| "info"
	| "dark"
	| "purple"
	| "orange"
	| "grey900"
	| "grey600"
	| "grey500"
	| "grey400"
	| "grey300"
	| "blue300"
	| "primary";

type Props = {
	value: number;
	/** When set, values above this display as `{max}+` (e.g. 99+). */
	max?: number;
	id?: string;
	theme?: CounterTheme;
	variant?: "filled" | "outline";
	size?: "small" | "standard";
	class?: string;
	style?: JSX.CSSProperties;
	title?: string;
};

/**
 * Round numeric badge — same themes as Pill, sized as a circle (or short
 * capsule for wider counts).
 *
 * [Design System →](http://localhost:5174/component/Counter)
 */
export const Counter = (props: Props) => {
	const [local, rest] = splitProps(props, [
		"value",
		"max",
		"theme",
		"size",
		"class",
		"variant",
	]);

	const display = () => formatCounterValue(local.value, local.max);

	return (
		<span
			class={`gvtui-counter ${local.class ?? ""}`}
			classList={{
				[`gvtui-counter--${local.theme}`]:
					!!local.theme && local.variant !== "outline",
				[`gvtui-counter--outline-${local.theme}`]:
					!!local.theme && local.variant === "outline",
				"gvtui-counter--outline": !local.theme && local.variant === "outline",
				"gvtui-counter--small": !!local.size && local.size !== "standard",
			}}
			data-digits={display().length}
			role="status"
			{...rest}
		>
			{display()}
		</span>
	);
};
